if (!customElements.get('lr-video-carousel')) {
  customElements.define('lr-video-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.track = this.querySelector('[data-video-track]');
      this.cards = [...this.querySelectorAll('[data-video-card]')];
      this.videos = this.cards.map(card => card.querySelector('video'));
      this.dots = [...this.querySelectorAll('[data-video-dot]')];
      this.previous = this.querySelector('[data-video-previous]');
      this.next = this.querySelector('[data-video-next]');
      this.cards.forEach((card, index) => {
        const video = this.videos[index];
        const button = card.querySelector('[data-video-play]');
        button.addEventListener('click', async () => {
          this.videos.forEach(other => { if (other !== video) other.pause(); });
          if (!video.src) { video.src = video.dataset.src; video.load(); }
          video.controls = true;
          try { await video.play(); }
          catch (_) { card.querySelector('[data-video-status]').textContent = 'Unable to play this video. Please try again.'; }
        }, options);
        video.addEventListener('play', () => { button.hidden = true; card.querySelector('[data-video-status]').textContent = ''; }, options);
        video.addEventListener('pause', () => { button.hidden = false; }, options);
        video.addEventListener('ended', () => { button.hidden = false; }, options);
      });
      this.previous.addEventListener('click', () => this.go(this.index - 1), options);
      this.next.addEventListener('click', () => this.go(this.index + 1), options);
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index), options));
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.videos.forEach(video => video.pause()); }, options);
      this.resize = new ResizeObserver(() => this.update()); this.resize.observe(this.track);
      this.inView = new IntersectionObserver(entries => entries.forEach(entry => { if (!entry.isIntersecting) this.videos.forEach(video => video.pause()); }));
      this.inView.observe(this);
      this.cardObserver = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.intersectionRatio < 0.6) entry.target.querySelector('video').pause(); }), { root: this.track, threshold: 0.6 });
      this.cards.forEach(card => this.cardObserver.observe(card));
      this.update();
    }
    update() {
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.step = this.cards[0].getBoundingClientRect().width + gap;
      this.max = Math.max(0, this.cards.length - Math.round((this.track.clientWidth + gap) / this.step));
      this.index = Math.min(this.max, Math.max(0, Math.round(this.track.scrollLeft / this.step)));
      this.previous.disabled = this.index === 0;
      this.next.disabled = this.index === this.max;
      this.dots.forEach((dot, index) => { dot.hidden = index > this.max; dot.setAttribute('aria-current', String(index === this.index)); });
    }
    go(index) {
      this.track.scrollTo({ left: Math.min(this.max, Math.max(0, index)) * this.step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    disconnectedCallback() {
      this.videos?.forEach(video => video.pause());
      this.events?.abort(); this.resize?.disconnect(); this.inView?.disconnect(); this.cardObserver?.disconnect(); this.ready = false;
    }
  });
}
